import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';
import { useI18n } from '../i18n';
import Navbar from './Navbar';
import Footer from './Footer';

// Wraps content behind authentication. Shows a friendly gate for anonymous users.
export const AuthGate = ({ children, eyebrow }) => {
  const { user, loading } = useAuth();
  const { t } = useI18n();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0C0E] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (user) return children;

  return (
    <div className="min-h-screen bg-[#0B0C0E]">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 relative">
        <div className="absolute inset-0 sc-grid-pattern opacity-25 pointer-events-none" />
        <div className="relative sc-card p-8 md:p-12 text-center" data-testid="auth-gate">
          <div className="w-14 h-14 rounded-full bg-amber-500/10 border border-amber-500/40 flex items-center justify-center text-amber-500 mx-auto mb-6">
            <Lock size={22} />
          </div>
          <div className="sc-mono-eyebrow text-amber-500 mb-3">{eyebrow || 'Zona de miembros'}</div>
          <h1 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {t('gate.title')}
          </h1>
          <p data-testid="auth-gate-subtitle" className="text-slate-400 leading-relaxed max-w-xl mx-auto mb-8">
            {t('gate.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/login"
              data-testid="gate-login-btn"
              className="bg-amber-500 hover:bg-amber-600 text-slate-950 font-semibold px-6 py-3 rounded-lg transition-colors"
            >
              {t('gate.login')}
            </Link>
            <Link
              to="/registro"
              data-testid="gate-register-btn"
              className="border border-[#2A2F3D] hover:border-amber-500/40 text-slate-200 font-semibold px-6 py-3 rounded-lg transition-colors"
            >
              {t('gate.register')}
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AuthGate;
